// Google Analytics Event Tracking Utility
// Tracks conversions and user interactions

export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
    console.log('GA Event:', eventName, eventParams);
  }
};

// Contact Form Submission
export const trackContactFormSubmission = (source = 'contact_form') => {
  trackEvent('contact_form_submit', {
    event_category: 'conversion',
    event_label: source,
    value: 1
  });
};

// CTA Button Clicks
export const trackCTAClick = (ctaName, location) => {
  trackEvent('cta_click', {
    event_category: 'engagement',
    event_label: ctaName,
    cta_location: location
  });
};

// Contact Us Button
export const trackContactUsClick = (location) => {
  trackEvent('contact_us_click', {
    event_category: 'conversion',
    event_label: 'contact_us',
    button_location: location
  });
};

// Blog CTA Click
export const trackBlogCTAClick = (blogTitle) => {
  trackEvent('blog_cta_click', {
    event_category: 'conversion',
    event_label: 'talk_to_cloud_architect',
    blog_title: blogTitle
  });
};

// Navigation Clicks
export const trackNavClick = (linkName) => {
  trackEvent('nav_click', {
    event_category: 'navigation',
    event_label: linkName
  });
};
